/**
 * @packageDocumentation
 * @module f1/security
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
const L = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;

export interface Uuid {
  /**
   * Create a universally unique identifier, the first number is
   * a unix timestamp, while the remaining string is a proper guid
   *
   * @public
   * @function f1.uuid
   * @example
   *
   * ```ts
   * f1.uuid() => 1597283597446-123e4567-e89b-12d3-a456-426614174000
   * ```
   */
  (): string;
}

/**
 * @see Uuid
 */
export default () => {
  const uuid = L.replace(/[018]/g, (c: number) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );

  return `${Date.now()}-${uuid}`;
};
